import { ApiGameListItem, IGameListItem } from '../../../../types/ApiTypes';
import { getGameStatusByDate } from '../../../games/getGameStatusByDate/getGameStatusByDate';

// Lekki odpowiednik transformGame dla widoków-list (Historia/Aktywne). Nie ciągnie
// pełnego szablonu — tylko pola, które listy realnie renderują + liczbę pytań. GMT-801.
export const transformGameListItem = (apiGame: ApiGameListItem): IGameListItem => {
  const startDate = new Date(apiGame.startDate);
  const endDate = new Date(apiGame.endDate);

  return {
    id: apiGame.id,
    startDate,
    endDate,
    isAvailableToJoin: apiGame.isAvailableToJoin,
    code: apiGame.code,
    numberOfPlayers: apiGame.numberOfPlayers,
    status: getGameStatusByDate({ startDate, endDate }),
    owner: apiGame.owner,
    template: {
      id: apiGame.template.id,
      name: {
        id: apiGame.template.name.id,
        translations: apiGame.template.name.translations.map(tr => ({
          lang: tr.lang,
          value: tr.value,
        })),
      },
      city: apiGame.template.city,
      gameType: apiGame.template.gameType?.code ?? null,
      coordinates: apiGame.template.coordinates
        ? {
            lat: +apiGame.template.coordinates.latitude,
            lng: +apiGame.template.coordinates.longitude,
            id: apiGame.template.coordinates.id,
          }
        : undefined,
      questionCount: apiGame.template.questionCount,
    },
  };
};
